import React from "react";
import { useTranslation } from "react-i18next";
import { AddTriangleBox, WalletCreationWelcomeImage } from "../../../../assets/icons";
import { BenefitRow } from "../../../../common/components/benefits-row/BenefitRow";
import sharedStyles from "../../../../styles/WelcomePage.module.scss";
import Button from "../../../../common/ekedc-components/button/Button";

interface WalletOnboardingScreenProps {
	onContinue: () => void;
}

const WalletOnboardingScreen: React.FC<WalletOnboardingScreenProps> = ({ onContinue }) => {
	const { t } = useTranslation();
	return (
		<div className={sharedStyles.screen}>
			<WalletCreationWelcomeImage className={sharedStyles.image} />
			<h1 className={sharedStyles.title}>{t("wallet.web.getStartedWithYourWallet")}</h1>
			<p className={sharedStyles.description}>{t("wallet.walletOnboardingDescription")}</p>
			<div className={sharedStyles.benefitsContainer}>
				<BenefitRow badge="9" title={t("wallet.walletOnboardingDedicatedAccountNumberTitle")} description={t("wallet.walletOnboardingDedicatedAccountNumberDescription")} />
				<BenefitRow badge="" title={t("wallet.walletOnboardingAddFundsTitle")} description={t("wallet.walletOnboardingAddFundsDescription")} leftIcon={<AddTriangleBox />} />
			</div>
			{/* <button className={sharedStyles.continueBtn} onClick={onContinue}>
				{t("common.actions.continueKey")}
			</button> */}
			<Button  onClick={onContinue} variant="primary">
				{t("common.actions.continueKey")}
			</Button>
		</div>
	);
};

export default WalletOnboardingScreen;
